export default {"src":"/_next/static/media/COP.ee2d2a15.svg","height":18,"width":18};